import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import nl2br from 'react-newline-to-break';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

export class Row extends Component {
    constructor(props) {
        super(props)
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.handleSendMail = this.handleSendMail.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
        this.handleChangeCheckBoxBulkCopy = this.handleChangeCheckBoxBulkCopy.bind(this);
    }
    /**
     * Listen on click edit button
     */
    handleEdit() {
        if (typeof this.props.onEdit === 'function') {
            this.props.onEdit(this.props.data);
        }
    }

    /**
     * Listen on click view button
     */
    handleDetail() {
        if (typeof this.props.onDetail === 'function') {
            this.props.onDetail(this.props.data);
        }
    }

    /**
     * Listen on click delete button
     */
    handleDelete() {
        if (typeof this.props.onDelete === 'function') {
            this.props.onDelete(this.props.data);
        }
    }

    handleChangeCheckBoxBulkCopy(e) {
        if (typeof this.props.onChangeCheckBoxBulkCopy === 'function') {
            this.props.onChangeCheckBoxBulkCopy(e, this.props.data);
        }
    }

    handleChangeStatus(event) {
        this.props.onHandleChangeStatus(event.target.checked, event.target.value);
    }

    handleSendMail() {
        this.props.onSendMail(this.props.data);
    }

    formatDate(date, format) {
        if (date){
                var d = new Date(date.replace(/-/g,"/")),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    hour = '' + d.getHours(),
                    minute = '' + d.getMinutes(),
                    second = '' + d.getSeconds(),
                    year = d.getFullYear();

                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;
                if (hour.length < 2) hour = '0' + hour;
                if (minute.length < 2) minute = '0' + minute;
                if (second.length < 2) second = '0' + second;

                return format.replace("Y", year).replace("M", month).replace("D", day).replace("h", hour).replace("m", minute).replace("s", second);
        }
        return '';
    }

    onChangeCheckBox() {
        if ($('.form-check-input :checked').length == $('.form-check-input').length) {
            $('#all').prop('checked', true);
        } else {
            $('#all').prop('checked', false);
        }
    }


    onClickCheckBoxBulkCopy(e) {
        e.stopPropagation();
    }

    getValueOfObject(val, names) {
        names = names.split('.');
        while (val && names.length) {
            val = val[ names.shift() ];
        }
        return val;
    }

    render() {
        // console.log(this.props.selectedJobIds);
        return (
                <tr className={this.props.removeClick ? null : this.props.color + ' clickable'} onClick={this.props.removeClick ? null : this.handleEdit}>
                    {this.props.header.map((item, i) =>{
                        var pre = item.hasOwnProperty('prefix')?item.prefix:'';
                        var pre_price_zero = item.hasOwnProperty('prefix_price_zero') ? item.prefix_price_zero: '';
                        var suff = item.hasOwnProperty('suffix')?item.suffix:'';
                        if(item.type == 'array'){
                                return(
                                        <td key={i} data-label={item.title}>
                                                {this.props.data[item.name].map((v, i) =>
                                                        <span key={i}><span className="btn btn-success btn-sm">{ v.name }</span>&nbsp;</span>
                                                )}
                                        </td>
                                )
                        }else if(item.type == 'object'){
                            return <td key={i}>{ this.getValueOfObject(this.props.data,item.name) }</td>
                        }else if(item.type == 'age'){
                            var age = moment().diff(this.props.data[item.name], 'years');
                            return <td key={i}>{age ? pre + age + suff : '-' }</td>
                        }else if (item.type == 'action') {
                                return(
                                        <td key={i} data-label={item.title}>
                                                { (item.elements.indexOf('view') > -1 && item.view_except_ids.indexOf(this.props.data['id']) == -1 ) ? (
                                                        <span><span onClick={this.handleView} className="glyphicon glyphicon-eye-open"> </span> </span>
                                                ) : ''
                                                }
                                                { (item.elements.indexOf('edit') > -1 && item.edit_except_ids.indexOf(this.props.data['id']) == -1 ) ? (
                                                        <span><i onClick={this.handleEdit} className="material-icons md-18 clickable">edit</i>　</span>
                                                ) : ''
                                                }
                                                { (item.elements.indexOf('delete') > -1 && item.delete_except_ids.indexOf(this.props.data['id']) == -1 ) ? (
                                                        <span><i onClick={this.handleDelete} className="material-icons md-18 clickable">delete</i>　</span>
                                                ) : ''
                                                }
                                        </td>
                                )
                        } else if (item.type == 'date') {
                                return(
                                        <td key={i} data-label={item.title}>{this.props.data[item.name] != null? this.formatDate(this.props.data[item.name], 'Y年M月D日'):'' }</td>
                                )
                        } else if (item.type == 'date_time') {
                                return(
                                        <td key={i} data-label={item.title}>{this.props.data[item.name] != null? this.formatDate(this.props.data[item.name], 'Y年M月D日 h:m'):'' }</td>
                                )
                        } else if (item.type == 'checkbox') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            {this.props.data.status == 0 || this.props.data.status ==98 ?
                                            <div className="form-check">
                                                <input value={this.props.data[item.name]} onChange={this.handleChangeStatus} type="checkbox" className="form-check-input" data-status={this.props.data.status} disabled/>
                                            </div>
                                            : ''}
                                        </td>
                                )
                        } else if (item.type == 'checkbox_receipt') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            {this.props.data[item.name] != null ?
                                            <div className="form-check">
                                                <input name={item.name} value={this.props.data[item.name]}  onChange={this.onChangeCheckBox} type="checkbox" className="form-check-input"/>
                                            </div>
                                            : ''}
                                        </td>
                                )
                        } else if (item.type == 'gender') {
                                return(
                                        <td key={i} data-label={item.title}>{ this.props.data[item.name] == 1 ? '男性' : this.props.data[item.name] == 2 ? '女性' : '' }</td>
                                )
                        } else if (item.type == 'approval_type') {
                                return(
                                        <td key={i} data-label={item.title}>{ this.props.data[item.name] == 'staff' ? (
                                                <span className="btn btn-primary btn-sm">ワーカー</span>
                                        ) : (
                                                <span className="btn btn-warning btn-sm">依 頼 者</span>
                                        )}
                                        </td>
                                )
                        } else if (item.type == 'option') {
                                return(
                                        <td key={i} data-label={item.title}>{ item.option.hasOwnProperty(this.props.data[item.name]) ? (
                                                <span className={item.option[this.props.data[item.name]]['classHTML']}>{item.option[this.props.data[item.name]]['text']}</span>
                                        ) : (
                                                ''
                                        )}
                                        </td>
                                        )
                        } else if (item.type == 'status3') {
                                return(
                                        <td key={i} data-label={item.title}>{ this.props.data[item.name] == 1 ? (
                                                <span className="btn btn-success btn-sm">採　用</span>
                                        ) : this.props.data[item.name] == 9 ? (
                                                <span className="btn btn-warning btn-sm">不採用</span>
                                        ) : (
                                                <span className="btn btn-default btn-sm">未決定</span>
                                        )}
                                        </td>
                                )
                        } else if (item.type == 'text_break_line') {
                                return(
                                        <td key={i} data-label={item.title}>{nl2br(this.props.data[item.name])}
                                        </td>
                                        )
                        } else if (item.type == 'status_option') {
                                return(
                                        <td key={i} data-label={item.title}><strong className={item.option[this.props.data[item.name]]['classHTML']}>{item.option[this.props.data[item.name]]['text']}</strong>
                                        </td>
                                        )
                        } else if (item.type == 'text_limit') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <span className="width-limit">{this.props.data[item.name]}</span>
                                        </td>
                                        )
                        } else if (item.type == 'link_job_edit') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.message_threads_job_id ? "/jobs/edit/" + this.props.data.message_threads_job_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_job_edit_houjin') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.message_threads_job_id ? "/houjin/jobs/edit/" + this.props.data.message_threads_job_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_point_edit') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.id ? "/points/edit/" + this.props.data.id : ''}>{this.props.data.id}</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_client_id') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.client_id ? "/accounts/edit/" + this.props.data.client_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_staff_id') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.staff_id ? "/accounts/edit/" + this.props.data.account_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'text_message_content') {
                                return(
                                        <td width="500" key={i} data-label={item.title}>
                                            {this.props.data[item.name]}
                                        </td>
                                        )
                        } else if (item.type == 'convert_to_number') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            {this.props.data[item.name] ? pre + parseInt(this.props.data[item.name]).toLocaleString() + suff : ''}
                                        </td>
                                        )
                        } else if (item.type == 'convert_to_number_with_zero') {
                                return(
                                        <td key={i} data-label={item.title}>
                                             {this.props.data[item.name] ? pre + parseInt(this.props.data[item.name]).toLocaleString() + suff : pre_price_zero + 0}
                                        </td>
                                        )
                        } else if (item.type == 'link_points') {
                            var [first_last_name, id, name]= this.props.data[item.name] ? this.props.data[item.name].split('-') : '';
                            if (id && first_last_name) {
                                return (
                                    <td key={i} data-label={item.title}>
                                        {id ? first_last_name + ' (' + id + ')' : '-'}
                                    </td>
                                )
                            } else {
                                return (
                                    <td key={i} data-label={item.title}>
                                        {id ? id : '-'}
                                    </td>
                                )
                            }
                        } else if (item.type == 'point_link_job_edit') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.job_id ? "/jobs/edit/" + this.props.data.job_id : ''}>{ this.props.data[item.name] }</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_from_ticket_id') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.ticket_id ? "/tickets/edit/" + this.props.data.ticket_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_client_client_id') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.client_client_id ? "/accounts/edit/" + this.props.data.client_client_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'link_worker_client_id') {
                                return(
                                        <td key={i} data-label={item.title}>
                                            <a className="text-primary" href={this.props.data.worker_client_id ? "/accounts/edit/" + this.props.data.worker_client_id : ''}>{this.props.data[item.name]}</a>
                                        </td>
                                        )
                        } else if (item.type == 'btn_edit') {
                            return(
                                <td key={i} data-label={item.title}>
                                    { (this.props.data.status == 0) ?
                                        <a onClick={this.handleEdit} className="btn btn-light">編集</a>
                                        :
                                        <a onClick={this.handleDetail} className="btn btn-light">閲覧</a>
                                    }
                                </td>
                            )
                        } else if (item.type == 'btn_status') {
                            if (this.props.data.status == 4) {
                                return (
                                    <td key={i} data-label={item.title}>
                                        <button disabled="disabled" className="btn btn-secondary btn-xs">処理済</button>
                                    </td>
                                )
                            } else if (this.props.data.status == 3) {
                                return (
                                    <td key={i} data-label={item.title}>
                                        <button disabled="disabled" className="btn btn-secondary btn-xs">処理中</button>
                                    </td>
                                )
                            } else if (this.props.data.status == 1) {
                                return (
                                    <td key={i} data-label={item.title}>
                                        <button disabled="disabled" className="btn btn-light btn-xs">配信済</button>
                                    </td>
                                )
                            } else {
                                return (
                                    <td key={i} data-label={item.title}>
                                        <button onClick={this.handleSendMail} className="btn btn-primary btn-xs">配信する</button>
                                    </td>
                                )
                            }
                        } else if (item.type == 'option_destination') {
                            if (this.props.data.destination_id) {
                                return (
                                    <td key={i} data-label={item.title}>{ item.option.hasOwnProperty(this.props.data[item.name]) ? (
                                            <span className={item.option[this.props.data[item.name]]['classHTML']}>{item.option[this.props.data[item.name]]['text'] + ' (' + this.props.data.destination_id + ')'}</span>
                                        ) : ( '')}
                                    </td>
                                )
                            } else {
                                return(
                                    <td key={i} data-label={item.title}>{ item.option.hasOwnProperty(this.props.data[item.name]) ? (
                                            <span className={item.option[this.props.data[item.name]]['classHTML']}>{item.option[this.props.data[item.name]]['text']}</span>
                                        ) : ( '' )}
                                    </td>
                                )
                            }
                        } else if (item.type == 'full_name') {
                            return(
                                <td key={i} data-label={item.title}>{this.props.data[item.name]}{ this.props.data.staffId ? ' (' + this.props.data.staffId + ')' : ''}
                                </td>
                            )
                        } else if (item.type == 'truncate' && this.props.data[item.name]) {
                            return(
                                <td key={i} data-label={item.title}>{this.props.data[item.name].toString().slice(0, item.truncateLength)}</td>
                            )
                        } else if (item.type == 'checkbox_bulk_copy') {
                            return(
                                    <td key={i} data-label={item.title} onClick={this.onClickCheckBoxBulkCopy} className="bg_white td_checkbutton">
                                        <div className="form-check">
                                            <input id={"bulk_copy"+this.props.data['id']} name={item.name+"[]"} value={this.props.data['id']} checked={this.props.selectedJobIds.includes(this.props.data['id'])} onChange={this.handleChangeCheckBoxBulkCopy} type="checkbox" className="form-check-input"/>
                                            <label class="form-check-label" for={"bulk_copy"+this.props.data['id']}>
                                            </label>
                                        </div>
                                    </td>
                            )

                        } else {
                                var cel = this.props.data[item.name] == null ? '-' : this.props.data[item.name];
                                return(
                                        <td key={i} data-label={item.title}>{ pre + cel + suff}</td>
                                )
                                }
                        })
                    }
                </tr>
                );
    }
}
const mapStateToProps = state => {
    const {selectedJobIds} = state.job
    return {
        selectedJobIds: selectedJobIds,
    }
}
export default withRouter(connect(mapStateToProps)(Row))